/* eslint-disable max-lines-per-function */
import dayjs from 'dayjs';
import { Suspense } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Day, YearMonthParams } from '@/domain/termine/type';
import { ListWeek } from '@/domain/termine/features/Calendar/List/ListWeek';
import { Link, Outlet, useParams } from 'react-router-dom';
import { buttonVariants } from '@/components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusLarge } from '@fortawesome/pro-regular-svg-icons';
import { cn } from '@/lib/utils';
import { CalendarSelect } from '@/domain/termine/features/Calendar/List/CalendarSelect';

export function List() {
  const { year, month } = useParams<YearMonthParams>();
  const monthDate = {
    year: year ?? `${new Date().getFullYear()}`,
    month: month ?? `${new Date().getMonth() + 1}`,
  };

  const firstDateOfDisplayedMonth = dayjs(
    `${monthDate.year}-${monthDate.month}`,
  );

  const startOfMonth = firstDateOfDisplayedMonth.startOf('month');
  const endOfMonth = firstDateOfDisplayedMonth.endOf('month');

  let current = startOfMonth.clone().startOf('week');
  const lastDay = endOfMonth.clone().endOf('week');

  const days: Day[] = [];
  while (current.isBefore(lastDay) || current.isSame(lastDay)) {
    days.push(current.clone());
    current = current.add(1, 'day');
  }

  const weeks: Day[][] = [];
  for (let i = 0; i < days.length; i += 7) {
    weeks.push(days.slice(i, i + 7));
  }

  return (
    <div className="rounded-xl relative">
      <Suspense fallback={<Skeleton className="w-full" />}>
        <div className="text-sm text-gray-400 font-medium">
          {weeks.map((week) => (
            <ListWeek
              key={week[0].isoWeek()}
              week={week}
              currentMonth={firstDateOfDisplayedMonth.month() + 1}
              currentYear={firstDateOfDisplayedMonth.year()}
            />
          ))}
        </div>
      </Suspense>
      <div className="flex sm:hidden justify-end">
        <div className="fixed bottom-8 z-40 flex p-2 bg-white rounded-lg shadow-xs gap-2">
          <CalendarSelect />
          <Link
            className={cn(buttonVariants({ variant: 'default', size: 'icon' }))}
            to={`/termine/uebersicht/${year}/${month}/create`}
            onClick={(e) => e.currentTarget.blur()}>
            <FontAwesomeIcon icon={faPlusLarge} size="lg" />
          </Link>
        </div>
      </div>
      <Outlet />
    </div>
  );
}
